import { Component } from "react";
import { FormControl, Input, IconButton, Flex, Textarea, Text } from "@chakra-ui/react";
import { MdCheck, MdClose } from "react-icons/md";

export interface QuickNumberFormProps {
  onSubmit: (formNumber: number) => void;
  onClose: () => void;
  initialNumber?: number;
  minLimit: number;
  maxLimit: number;
  showLimitText?: boolean
}

class QuickNumberForm extends Component<QuickNumberFormProps> {
  state = {
    formNumber: this.props.initialNumber || 0
  }

  renderFormContents = () => {
    return (
      <Input 
      onChange={(e) => {
        const formNumber = parseInt(e.target.value);
        this.setState({ formNumber: Math.abs(formNumber) || this.props.minLimit });
      }}
        value={this.state.formNumber} 
        style={{ borderRadius: 25}}
        textAlign={'right'}
      />        
    )
  }

  render = () => {
    const { onSubmit, onClose, minLimit, maxLimit, showLimitText } = this.props;
    const { formNumber } = this.state
    const canSubmit = formNumber >= minLimit && formNumber <= maxLimit
    return (
      <Flex direction={'row'} align={'center'}>
      <FormControl width={20}>
      {this.renderFormContents()}
      </FormControl>
      <IconButton 
        onClick={() => {
          if (canSubmit) {
            onSubmit(formNumber)
          }
        }}
        aria-label='Submit' 
        colorScheme={canSubmit ? 'green' : undefined}
        borderRadius={25} 
        ml={1} 
      >
        <MdCheck />
      </IconButton>
      <IconButton 
        onClick={() => onClose()}
        aria-label='Close' 
        borderRadius={25} 
        ml={1} 
      >
        <MdClose />
      </IconButton>
      { showLimitText && minLimit && maxLimit && !canSubmit && (
        <Text color={'#CA0000'} fontSize={'xs'} pl={2}>{`Limit: ${minLimit} to ${maxLimit}`}</Text>
      )}
      </Flex>
    )
  }
}

export default QuickNumberForm;